/* import __COLOCATED_TEMPLATE__ from './ticket-links-slot.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class TicketLinksSlotComponent extends Component {
  @service messengerSettingsTargetUserProvider;
  @service intl;

  get showBanner() {
    if (!this.args.slotExists) {
      return false;
    } else {
      return (
        this.ticketLinks.length === 0 ||
        (this.ticketLinks.length === 1 && this.ticketLinks.firstObject.validations.isInvalid)
      );
    }
  }

  get ticketLinks() {
    return this.args.slot?.ticketLinks?.toArray() || [];
  }

  get userTypeLabel() {
    return this.messengerSettingsTargetUserProvider.isUserType
      ? this.intl.t('messenger.target-types.users-label')
      : this.intl.t('messenger.target-types.visitors-label');
  }
}
